import useReadAloudMode from "@/view/ReadAloudControls/useReadAloudMode";
import useUserContentUIContext from "@/view/utils/useUserContentUIContext";
import { levelAlertPlaceholder, rootCss } from "./LevelAlert.style";

import type ContentLevel from "@/types/models/ContentLevel.interface";

interface LevelAlertProps {
  levels: ContentLevel[] | undefined;
}

const LevelAlert = ({ levels }: LevelAlertProps) => {
  const { isReadAloudModeActive } = useReadAloudMode();
  const { uiType } = useUserContentUIContext();

  if (!levels?.length || levels?.length > 1) return null;

  // We don't want to show this alert when read aloud is active,
  // but we do want the space for this alert to be maintained
  // to keep the page from jumping.
  if (isReadAloudModeActive) {
    return <div css={levelAlertPlaceholder(uiType)} />;
  }

  return (
    <div css={rootCss(uiType)}>
      This content is published at the original level only.
    </div>
  );
};

export default LevelAlert;
